<div class="page">
  <h1 class="title">{{ "general.users" | translate }}</h1>
  <div fxLayout="column">
    <form fxFlex="100" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="space-between center" [formGroup]="userForm"
          #form="ngForm" class="mg-b-22">
      <mat-form-field fxFlex="20" appearance="outline">
        <mat-label>{{ 'general.user' | translate }}</mat-label>
        <input formControlName="username" id="username" name="username" matInput [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUsername">
          @if (isLoading) {
            <mat-option>
              <mat-progress-spinner mode="indeterminate" diameter="25" class="spinner"></mat-progress-spinner>
            </mat-option>
          } @else {
            @for (user of usersByUsername; track user) {
              <mat-option [value]="user">
                {{ user.username }} | {{ user.firstName }} {{ user.surname }} | {{ user.email }}
              </mat-option>
            }
          }
        </mat-autocomplete>
        @if (userNotFound) {
          <mat-error class="form-field-error user-not-found">
            {{ 'general.user-not-found' | translate }}
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field fxFlex="20" appearance="outline">
        <mat-label>{{ 'general.name' | translate }}</mat-label>
        <input formControlName="name" name="name" matInput
        />
      </mat-form-field>

      <mat-form-field fxFlex="20" appearance="outline">
        <mat-label>{{ 'general.email' | translate }}</mat-label>
        <input formControlName="email" name="email" matInput/>
        @if(userForm.get('email')?.hasError('email')){
          <mat-error>E-mail com formato inválido.</mat-error>
        }
      </mat-form-field>

      <mat-form-field fxFlex="20" appearance="outline">
        <mat-label>{{ 'general.profile' | translate }}</mat-label>
        <mat-select formControlName="profile" name="profile">
          <mat-option value="Administrador">{{ 'general.administrator' | translate }}</mat-option>
          <mat-option value="Aprovador de Pedidos">{{ 'general.Order Approver' | translate }}</mat-option>
          <mat-option value="Aprovador de Orçamentos">{{ 'general.Budget Approver' | translate }}</mat-option>
          <mat-option value="Solicitante">{{ 'general.applicant' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-flat-button class="add-button mg-b-22" [disabled]="!userForm.valid  || !userSelected"
              (click)="isEdit ? updateUser() : addUser()">
        {{ (isEdit ? "button.update" : "button.add") | translate }}
      </button>
    </form>

    <mat-form-field class="filter">
      <mat-label id="filter">{{ "general.filter" | translate }}</mat-label>
      <input matInput [formControl]="filter">
    </mat-form-field>


    <div class="users-container">
      <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">
            {{ 'general.user' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.username }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">
            {{ 'general.name' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">
            {{ 'general.email' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>

        <ng-container matColumnDef="profile">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">
            {{ 'general.profile' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.profile }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="table-header action">
            {{ 'general.action' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="action">
            <button mat-icon-button class="custom-red" (click)="deleteUser(element)">
              <mat-icon matTooltip="{{'button.delete-tooltip' | translate}}" style="color: #B41E2A;">
                delete
              </mat-icon>
            </button>
            <button mat-icon-button (click)="editUser(element)">
              <mat-icon matTooltip="{{'button.edit-tooltip' | translate}}">
                edit
              </mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
      <mat-paginator
              [length]="pageable.length"
              [pageSize]="pageable.pageSize"
              (page)="pageChange($event)"
              [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons>
      </mat-paginator>
  </div>
</div>
<app-breadcrumbs [breadcrumbsData]="breadcrumbsData"></app-breadcrumbs>
